import type { ProxyHeadersPluginCreator } from './getProxyHeadersServerPlugin';

export * from './context';

export const getProxyHeadersPlugin: ProxyHeadersPluginCreator =
    process.env.BUILD_TARGET === 'server'
        ? require('./getProxyHeadersServerPlugin').getProxyHeadersPlugin
        : () => undefined;
